module.exports = __webpack_public_path__ + "static/media/cover5.bd375b7c.jpg";